import { PageConfType } from 'base/utils/parse-app-context';

export const pages: Record<string, Partial<PageConfType>> = {
    brand: {
        viewType: 'brand',
        seoCode: 'brand',
    },
    index: {
        viewType: 'index',
        seoCode: 'index',
    },
    list: {
        viewType: 'list',
        seoCode: 'list',
        queryKeys: ['p', 'order', 'topp', 'topv'],
    },
    search: {
        viewType: 'search',
        seoCode: 'list',
        queryKeys: ['q', 'p', 'order', 'topp', 'topv'],
    },
    diyPool: {
        viewType: 'diy_pool',
        seoCode: 'DIY_POOLS',
    },
    detail: {
        viewType: 'detail',
        seoCode: 'detail',
    },
    cart: {
        viewType: 'cart',
    },
    checkout: {
        viewType: 'checkout',
        needAuth: ['checkoutId'],
    },
    pay: {
        viewType: 'card',
    },
    purchase: {
        viewType: 'purchase',
        queryKeys: ['success'],
    },
    login: {
        viewType: 'customers/login',
    },
    account: {
        viewType: 'customers/account',
        needAuth: true,
    },
    profile: {
        viewType: 'customers/profile',
        needAuth: true,
    },
    address: {
        viewType: 'customers/address',
        needAuth: true,
    },
    orders: {
        viewType: 'customers/orders',
        needAuth: true,
    },
    order: {
        viewType: 'customers/order',
        needAuth: true,
    },
    review: {
        viewType: 'customers/order_review',
        needAuth: true,
    },
    refund: {
        viewType: 'refund',
        needAuth: true,
    },
    packages: {
        viewType: 'customers/packages',
        needAuth: true,
    },
    track: {
        viewType: 'customers/track',
        needAuth: true,
    },
    coupons: {
        viewType: 'customers/coupons',
        needAuth: true,
    },
    points: {
        viewType: 'customers/points',
        detail: 'history',
        needAuth: true,
    },
    pointsMarketplace: {
        viewType: 'customers/points',
        detail: 'pointsMarketplace',
        seoCode: 'pointsMarketplace',
        needAuth: true,
    },
    messageCenter: {
        viewType: 'customers/message_center',
        needAuth: true,
    },
    security: {
        viewType: 'password',
        needAuth: true,
    },
    changeEmail: {
        viewType: 'customers/other',
        detail: 'changeEmail',
        seoCode: 'changeEmail',
    },
    verifyEmail: {
        viewType: 'customers/other',
        detail: 'verifyEmail',
    },
    resetPassword: {
        viewType: 'customers/reset_password',
    },
    settings: {
        viewType: 'customers/other',
        detail: 'settings',
        seoCode: 'settings',
    },
    locale: {
        viewType: 'customers/other',
        detail: 'locale',
        seoCode: 'locale',
    },
    help: {
        viewType: 'help',
    },
    helpCenter: {
        viewType: 'help_center',
    },
    weeklyDeal: {
        viewType: 'marketing',
        seoCode: 'weeklyDeal',
    },
    blackFriday: {
        viewType: 'marketing',
        seoCode: 'blackFriday',
    },
    smartGrowSystem: {
        viewType: 'marketing',
        seoCode: 'smartGrowSystem',
    },
    technicalGuide: {
        viewType: 'technical_guide',
    },
    guides: {
        viewType: 'guides',
    },
    supportGuide: {
        viewType: 'guides',
        seoCode: 'supportGuide',
    },
    supportGuides: {
        viewType: 'guides',
        detail: 'supportGuides',
        seoCode: 'supportGuides',
    },
    brochure: {
        viewType: 'brochure',
        seoCode: 'brochure',
    },
    terplux: {
        viewType: 'brochure',
        seoCode: 'terplux',
    },
    blackFridayCheckIn: {
        viewType: 'activity',
    },
    winterSurprise: {
        viewType: 'activity',
        detail: 'winterSurprise',
        seoCode: 'winterSurprise',
    },
    trickOrTreat: {
        viewType: 'activity',
        detail: 'trickOrTreat',
        seoCode: 'trickOrTreat',
    },
    testerClub: {
        viewType: 'activity',
        detail: 'testerClub',
        seoCode: 'testerClub',
    },
    testerClubResult: {
        viewType: 'activity',
        detail: 'testerClubResult',
        seoCode: 'testerClubResult',
        i18nNamespace: 'testerClub',
    },
    testerClubReview: {
        viewType: 'activity',
        detail: 'testerClubReview',
        i18nNamespace: 'testerClub',
    },
    superSlots: {
        viewType: 'activity',
        detail: 'superSlots',
        seoCode: 'superSlots',
    },
    vgrowGrowingChallenge: {
        viewType: 'activity',
        detail: 'vgrowGrowingChallenge',
        seoCode: 'vgrowGrowingChallenge',
    },
    referral: {
        viewType: 'marketing',
        detail: 'referral',
        seoCode: 'referral',
    },
    referAFriend: {
        viewType: 'customers/other',
        detail: 'refer_a_friend',
        seoCode: 'referAFriend',
        needAuth: true,
    },
    ageGate: {
    },
    redeemRewards: {
        viewType: 'activity',
        detail: 'redeemRewards',
        seoCode: 'redeemRewards',
    },
    yearReview2024: {
        viewType: 'marketing',
        detail: 'yearReview2024',
        seoCode: 'yearReview2024',
    },
    '420CheckIn': {
        viewType: 'marketing',
        detail: '420CheckIn',
        seoCode: '420CheckIn',
    },
    brandStory: {
        viewType: 'marketing',
        detail: 'brandStory',
        seoCode: 'brandStory',
    },
    community: {
        viewType: 'marketing',
        detail: 'community',
        seoCode: 'community',
    },
    affiliate: {
        viewType: 'marketing',
        detail: 'affiliate',
        seoCode: 'affiliate',
    },
    communityArticle: {
        viewType: 'marketing',
        detail: 'communityArticle',
        seoCode: 'communityArticle',
    },
    crowdFunding: {
        viewType: 'activity',
        detail: 'crowdFunding',
        seoCode: 'crowdFunding',
    },
    promotionalSale: {
        viewType: 'marketing',
        detail: 'promotionalSale',
        seoCode: 'promotionalSale',
    },
    winterGrow: {
        viewType: 'marketing',
        detail: 'winterGrow',
        seoCode: 'winterGrow',
    },
    xmas2025: {
        viewType: 'marketing',
        detail: 'xmas2025',
        seoCode: 'xmas2025',
    }
};